/* eslint-disable no-unused-vars */

import ButtonStatus from '@components/button-status';
import HighlightText from '@components/highlight-text';
import Icon from '@components/icon-component';

import style from './style.module.scss';
import _ from 'lodash';

const TaskDetail = ({
  img,
  task,
  btnText,
  onClick,
  spanText,
  dot,
  highlight,
  allDoneTasks,
  allTasksForSite,
  notShowInProgressCount = false,
  showBtnGrayCount = false,
  taskName,
  recordCount = 0,
  showBorderOnTop = false
}) => {
  const buttonClass = `btn-status btn1 ${allDoneTasks?.length === 0 && 'btn-overdue'} ${
    allDoneTasks?.length > 0 && allTasksForSite?.length > allDoneTasks?.length && 'btn-progress'
  }  ${allDoneTasks?.length === allTasksForSite?.length && 'btn-done'}  ${
    (taskName === 'Work requests' || taskName === 'New or edited assets') && style.btnWorkRequest
  } `;

  return (
    <div
      className={`${style.taskDetail} ${showBorderOnTop && style.showBorderOnTop} `}
      onClick={onClick}
    >
      <div
        className={style.innerDiv}
        style={{
          width: '100%'
        }}
      >
        {img && img}
        <p className={style.taskName} style={{ marginLeft: img ? '20px' : '0px' }}>
          {spanText && (
            <span className={style.dull}>
              <HighlightText text={spanText} highlight={highlight} />
            </span>
          )}
          <HighlightText text={task} highlight={highlight} />
        </p>
      </div>
      <div
        className={style.innerDiv}
        style={{
          width: '100%',
          justifyContent: 'flex-end'
        }}
      >
        {!notShowInProgressCount && <ButtonStatus classes={buttonClass} Text={btnText} dot={dot} />}
        {showBtnGrayCount && (
          <div
            style={{
              marginLeft: '8px'
            }}
          >
            <ButtonStatus classes={`btn-status btn1 btn-count`} Text={btnText} />
          </div>
        )}
        {_.isNumber(recordCount) && recordCount > 0 && (
          <div
            style={{
              marginLeft: '4px'
            }}
          >
            <ButtonStatus classes={`btn-status btn1 btn-count`} Text={recordCount} />
          </div>
        )}

        <Icon name={'chevron-left'} alt="" className={style.leftIcon} />
      </div>
    </div>
  );
};

export default TaskDetail;
